import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/test.environment';
import { Observable } from 'rxjs';

export interface Project {
  projectNumber: number;
  projectName: string;
  pm: string;
  dateCreated: string | null;
  dateUpdated: string | null;
  outsourcePm: string | null;
  closedDate: string | null;
}

@Injectable({ providedIn: 'root' })
export class ProjectService {
  constructor(private http: HttpClient) {}

  getAllProjects(): Observable<Project[]> {
    return this.http.get<Project[]>(`${environment.apiBaseUrl}/api/projects/all`);
  }

  getProjectByNumber(projectNumber: number): Observable<Project> {
    return this.http.get<Project>(`${environment.apiBaseUrl}/api/projects/${projectNumber}`);
  }

  createProject(project: Project) {
    return this.http.post(`${environment.apiBaseUrl}/api/projects/create`, project);
  }
  
}
